import { useLocation, useNavigate } from 'react-router-dom'
import Button from '../components/ui/Button'
import { printCaseFromForm } from '../utils/printCasePdf'
import ar from '../locales/ar.json'
import { WifiOff, AlertTriangle, FileText, Search } from 'lucide-react'

const t  = ar.success
const to = ar.offline

export default function SubmitSuccessPage() {
  const { state } = useLocation()
  const navigate  = useNavigate()
  const caseData  = state?.case
  const formData  = state?.formData
  const queued    = state?.queued

  function handleDownloadPdf() {
    if (formData && caseData?.readable_id) {
      printCaseFromForm(formData, caseData.readable_id)
    } else if (caseData?.id) {
      window.open(`/api/v1/submissions/${caseData.id}/pdf`, '_blank')
    }
  }

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-4 py-12">
      {/* Header */}
      <header className="fixed top-0 right-0 left-0 bg-primary-700 text-white py-3 px-4 flex items-center gap-3 no-print">
        <img src="/logos/logo_icon.png" alt="" className="h-9 w-auto" />
        <span className="text-sm font-semibold">المنصة الوطنية لتوثيق الشهداء والمفقودين</span>
      </header>

      <div className="mt-16 card max-w-lg w-full text-center">
        {queued ? (
          <>
            <div className="w-14 h-14 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <WifiOff size={28} className="text-stone-500" />
            </div>
            <h1 className="text-xl font-bold text-stone-800 mb-2">{to.queued}</h1>
            <p className="text-stone-500 text-sm mb-6">
              تم حفظ طلبك في قائمة الانتظار. سيتم إرساله تلقائياً عند عودة الاتصال بالإنترنت.
            </p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-9 h-9 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-primary-700 mb-2">{t.title}</h1>
            <p className="text-stone-500 text-sm mb-6">{t.thankYou}</p>

            {caseData?.readable_id && (
              <div className="bg-primary-50 border border-primary-200 rounded-xl p-4 mb-6">
                <p className="text-xs text-primary-600 mb-1">{t.caseId}</p>
                <p className="text-2xl font-bold text-primary-800 tracking-wider font-mono">
                  {caseData.readable_id}
                </p>
                <p className="text-xs text-stone-400 mt-2">{t.keepId}</p>
                <p className="text-xs text-amber-700 mt-2 font-medium flex items-center justify-center gap-1">
                  <AlertTriangle size={13} className="flex-shrink-0" />
                  احتفظ بهذا الرقم — ستحتاجه لمتابعة حالة طلبك لاحقاً
                </p>
              </div>
            )}
          </>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {(caseData?.id || (formData && caseData?.readable_id)) && (
            <Button variant="secondary" onClick={handleDownloadPdf} className="flex items-center gap-1.5">
              <FileText size={15} />
              {t.downloadPdf}
            </Button>
          )}
          <Button variant="ghost" onClick={() => navigate('/track')} className="flex items-center gap-1.5">
            <Search size={15} />
            متابعة طلبي
          </Button>
          <Button variant="primary" onClick={() => navigate('/')}>
            {t.newCase}
          </Button>
        </div>
      </div>

      {/* Logo footer */}
      <div className="mt-8 text-center">
        <img src="/logos/logo_vertical.png" alt="" className="h-12 mx-auto mb-2 opacity-30" />
        <p className="text-xs text-stone-400">حفظاً للذاكرة، وإحقاقاً للحق</p>
      </div>
    </div>
  )
}
